import sandboxService from "src/shared/sandbox-service";
import Uri from "jsuri";
import { useProgramDomains } from "src/shared/store/program-domain/composables/useProgramDomains";
import { computed, toValue } from "vue";
import { useCampaignRootBuiltComponent } from "src/shared/store/component-built/composables";
import Session from "Session";
const getPreviewQueryParameters = (parameters) => {
    const sandbox = sandboxService.getPreviewByCampaignIdWithJourneyName(parameters.campaignId, parameters.journeyName);
    const queryParameters = {
        zone_name: parameters.zoneName,
        sandbox,
        creative_classification: parameters.creativeClassification,
        locale: parameters.variant,
        is_preview_mode: true,
        cacheBuster: parameters.campaignVersion,
    };
    return queryParameters;
};
const createPreviewUrl = (parameters) => {
    const baseUrl = `https://${parameters.programDomain}/core/preview.html`;
    const queryParameters = getPreviewQueryParameters(parameters);
    const uri = new Uri(baseUrl);
    Object.keys(queryParameters).forEach((queryParamKey) => {
        const queryParamValue = queryParameters[queryParamKey];
        uri.addQueryParam(queryParamKey, queryParamValue);
    });
    return String(uri.toString());
};
const createClientApiPreviewUrl = (parameters) => {
    const previewUrl = Session.getInstance().ajaxPrefilter.processUrl(`api:///v5/zones/${parameters.zoneName}`);
    const queryParameters = getPreviewQueryParameters(parameters);
    const accessToken = Session.getInstance().getAccessToken();
    const uri = new Uri(previewUrl);
    Object.keys(queryParameters).forEach((queryParamKey) => {
        const queryParamValue = queryParameters[queryParamKey];
        uri.addQueryParam("client_access_token", accessToken);
        uri.addQueryParam(queryParamKey, queryParamValue);
    });
    return String(uri.toString());
};
const selectPreviewUrlProgramDomain = (programDomains) => {
    let selected = programDomains.find((programDomain) => {
        return (programDomain.is_extole_domain &&
            programDomain.redirect_program_id === null);
    });
    if (!selected) {
        selected = programDomains.find((programDomain) => {
            return programDomain.redirect_program_id === null;
        });
    }
    return selected;
};
export const useFrontendAssetPreviewUrl = (frontendAsset, variant) => {
    const { programDomains } = useProgramDomains();
    const clientPreviewUrlProgramDomain = computed(() => selectPreviewUrlProgramDomain(programDomains.value));
    const { campaignRootBuiltComponent } = useCampaignRootBuiltComponent(() => toValue(frontendAsset).getCampaignId());
    const previewUrl = computed(() => {
        const frontendAssetValue = toValue(frontendAsset);
        const variantValue = toValue(variant);
        const campaignRootBuiltComponentValue = toValue(campaignRootBuiltComponent);
        const zonePreviewParameters = frontendAssetValue.getPreview();
        if (!zonePreviewParameters ||
            !clientPreviewUrlProgramDomain.value ||
            !campaignRootBuiltComponentValue) {
            return null;
        }
        const { owner } = campaignRootBuiltComponentValue;
        let programDomain;
        switch (owner) {
            case "EXTOLE":
                programDomain = "karma.extole.com";
                break;
            case "EXTOLE_BETA":
                programDomain = "extole-component-library.extole.io";
                break;
            default:
                programDomain = clientPreviewUrlProgramDomain.value.domain;
                break;
        }
        const basePreviewParameters = {
            programDomain,
            zoneName: zonePreviewParameters.zoneName,
            campaignId: zonePreviewParameters.campaignId,
            campaignVersion: zonePreviewParameters.campaignVersion.toString(),
            journeyName: zonePreviewParameters.journeyName,
            creativeClassification: zonePreviewParameters.creativeClassification,
            variant: variantValue,
        };
        if (frontendAssetValue.isClientApiPreview()) {
            return createClientApiPreviewUrl(basePreviewParameters);
        }
        else if (frontendAssetValue.type === "CREATIVE_ACTION") {
            return createPreviewUrl(basePreviewParameters);
        }
        else if (frontendAssetValue.type === "DISPLAY_ACTION") {
            return createPreviewUrl(Object.assign(Object.assign({}, basePreviewParameters), {
                creativeClassification: "PAGE",
            }));
        }
        else {
            return null;
        }
    });
    return {
        previewUrl,
    };
};
